/* ==========================================================================
   SUNDAY PAW CLUB — WINTER 2026 INTERACTION & CINEMATIC HERO
   3D Tilt, Local Snow Depth, Interactive Hotspots, Live Colorway Switcher
   ========================================================================== */

(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --------------------------------------------------------------------------
     1. Local Snow Particle Layer over Hero Photo
     -------------------------------------------------------------------------- */
  function initVisualSnow() {
    var canvas = document.querySelector('.winter-visual-snow');
    if (!canvas || reduced) return;

    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var width = 0;
    var height = 0;
    var flakes = [];
    var animFrame = null;
    var isVisible = true;

    function resize() {
      var rect = canvas.getBoundingClientRect();
      width = canvas.width = rect.width || 450;
      height = canvas.height = rect.height || 560;
    }

    function createFlakes() {
      flakes = [];
      var count = 36;
      for (var i = 0; i < count; i++) {
        flakes.push({
          x: Math.random() * width,
          y: Math.random() * height,
          radius: Math.random() * 2.0 + 0.8,
          speed: Math.random() * 0.8 + 0.4,
          drift: (Math.random() - 0.5) * 0.6,
          opacity: Math.random() * 0.6 + 0.25,
          swing: Math.random() * Math.PI * 2,
          swingSpeed: Math.random() * 0.03 + 0.015
        });
      }
    }

    function draw() {
      if (!isVisible) return;
      ctx.clearRect(0, 0, width, height);

      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.swing += f.swingSpeed;
        f.x += Math.sin(f.swing) * 0.4 + f.drift;
        f.y += f.speed;

        if (f.y > height + 5) {
          f.y = -5;
          f.x = Math.random() * width;
        }
        if (f.x > width + 5) {
          f.x = -5;
        } else if (f.x < -5) {
          f.x = width + 5;
        }

        ctx.beginPath();
        ctx.arc(f.x, f.y, f.radius, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255, 255, 255, ' + f.opacity + ')';
        ctx.shadowColor = 'rgba(104, 168, 232, 0.5)';
        ctx.shadowBlur = 3;
        ctx.fill();
      }

      animFrame = requestAnimationFrame(draw);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!isVisible) {
              isVisible = true;
              animFrame = requestAnimationFrame(draw);
            }
          } else {
            isVisible = false;
            if (animFrame) cancelAnimationFrame(animFrame);
          }
        });
      });
      io.observe(canvas);
    }

    window.addEventListener('resize', function () {
      resize();
      createFlakes();
    }, { passive: true });

    resize();
    createFlakes();
    animFrame = requestAnimationFrame(draw);
  }

  /* --------------------------------------------------------------------------
     2. Interactive 3D Perspective Tilt on Mouse Movement (Desktop only)
     -------------------------------------------------------------------------- */
  function initTiltHero() {
    var card = document.querySelector('[data-tilt-hero]');
    if (!card || reduced || window.innerWidth < 960) return;

    var raf = null;

    function onMouseMove(e) {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;

        var rotateX = ((centerY - y) / centerY) * 5;
        var rotateY = ((x - centerX) / centerX) * 5;

        card.style.transform = 'perspective(900px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg)';
      });
    }

    function onMouseLeave() {
      if (raf) cancelAnimationFrame(raf);
      card.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg)';
    }

    card.addEventListener('mousemove', onMouseMove, { passive: true });
    card.addEventListener('mouseleave', onMouseLeave, { passive: true });
  }

  /* --------------------------------------------------------------------------
     3. Live Colorway Switcher
     Two photo slots, "camel" (first colour) and "cream" (second colour).
     The label under the photo comes from each button's data-float, so the
     hero can feature any product without touching this file.
     -------------------------------------------------------------------------- */
  function initColorwaySwitcher() {
    var buttons = document.querySelectorAll('[data-switch]');
    var photosContainer = document.querySelector('.winter-visual__photos');
    var photos = document.querySelectorAll('[data-photo]');
    var floatColor = document.querySelector('[data-float-color]');

    if (!buttons.length || !photos.length) return;

    // Default ensure active photo is visible
    photos.forEach(function (p) {
      if (p.getAttribute('data-photo') === 'camel') {
        p.classList.add('is-active');
        p.style.opacity = '1';
        p.style.visibility = 'visible';
      }
    });

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetColor = btn.getAttribute('data-switch');

        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        if (photosContainer) {
          if (targetColor === 'cream') {
            photosContainer.classList.add('show-cream');
          } else {
            photosContainer.classList.remove('show-cream');
          }
        }

        photos.forEach(function (p) {
          if (p.getAttribute('data-photo') === targetColor) {
            p.classList.add('is-active');
            p.style.opacity = '1';
            p.style.visibility = 'visible';
          } else {
            p.classList.remove('is-active');
            p.style.opacity = '0';
            p.style.visibility = 'hidden';
          }
        });

        if (floatColor) {
          var label = btn.getAttribute('data-float');
          if (label) {
            floatColor.textContent = label;
          } else if (targetColor === 'cream') {
            floatColor.textContent = 'Cream · Sherpa Fleece · XS–XL';
          } else {
            floatColor.textContent = 'Camel · Suede Shell · XS–XL';
          }
        }
      });
    });
  }

  /* --------------------------------------------------------------------------
     4. Mobile Hotspots Touch Toggle
     -------------------------------------------------------------------------- */
  function initHotspots() {
    var hotspots = document.querySelectorAll('.winter-hotspot');
    if (!hotspots.length) return;

    hotspots.forEach(function (spot) {
      spot.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasActive = spot.classList.contains('is-open');
        hotspots.forEach(function (s) { s.classList.remove('is-open'); });
        if (!wasActive) spot.classList.add('is-open');
      });
    });

    document.addEventListener('click', function () {
      hotspots.forEach(function (s) { s.classList.remove('is-open'); });
    });
  }

  /* Initialize */
  function init() {
    initVisualSnow();
    initTiltHero();
    initColorwaySwitcher();
    initHotspots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();